import React, { Component } from 'react';
import { Card, CardBody, CardText, CardTitle, Col, Container, Row } from "reactstrap";

export default class Advantages extends Component {
    render() {
        return (
            <Container className='Home-icons'>


                <Row>
                    <Col md="3" sm="6" style={{minHeight:500}}>

                    </Col>


                </Row>
            </Container>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/home/Advantages.js